import { useEffect, useRef, useState } from 'react';
import { createWebSocket } from '../services/api';

export function useWebSocket(onMessage) {
  const [connected, setConnected] = useState(false);
  const wsRef = useRef(null);
  const reconnectTimeoutRef = useRef(null);

  useEffect(() => {
    const connect = () => {
      try {
        wsRef.current = createWebSocket(
          (data) => {
            setConnected(true);
            if (onMessage) onMessage(data);
          },
          (error) => {
            console.error('WebSocket error:', error);
            setConnected(false);
          },
          () => {
            setConnected(false);
            // Reconnect after 3 seconds
            reconnectTimeoutRef.current = setTimeout(connect, 3000);
          }
        );
      } catch (error) {
        console.error('Failed to create WebSocket:', error);
        setConnected(false);
        reconnectTimeoutRef.current = setTimeout(connect, 3000);
      }
    };

    connect();

    return () => {
      if (reconnectTimeoutRef.current) {
        clearTimeout(reconnectTimeoutRef.current);
      }
      if (wsRef.current) {
        wsRef.current.close();
      }
    };
  }, [onMessage]);

  return { connected, ws: wsRef.current };
}
